import { render } from "./ResetView.vue?vue&type=template&id=64b86232"
import script from "./ResetView.vue?vue&type=script&lang=js"
export * from "./ResetView.vue?vue&type=script&lang=js"

import "./ResetView.vue?vue&type=style&index=0&id=64b86232&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__